import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ScreenSize {
    mobile: boolean;
    tablet: boolean;
    tabletOrDesktop: boolean;
    desktop: boolean;
}

export interface Breakpoint {
    m: boolean;
    l: boolean;
    xl: boolean;
}
export interface ScreenState {
    screenSize: ScreenSize;
    breakpoint: Breakpoint;
}

const initialState: ScreenState = {
    screenSize: {
        mobile: false,
        tablet: false,
        tabletOrDesktop: false,
        desktop: false,
    },
    breakpoint: {
        m: false,
        l: false,
        xl: false,
    },
};

const screen = createSlice({
    name: 'screen',
    initialState,
    reducers: {
        setScreenSize: (state, action: PayloadAction<{ xl: boolean; l: boolean; m: boolean }>) => {
            const { xl, l, m } = action.payload;
            state.screenSize = {
                mobile: !xl && !l && !m,
                tablet: m,
                tabletOrDesktop: xl || l || m,
                desktop: xl || l,
            };

            state.breakpoint = { m, l, xl };
        },
    },
    selectors: {
        selectScreenSize: (state) => state.screenSize,
        selectBreakpoint: (state) => state.breakpoint,
    },
});

export const { setScreenSize } = screen.actions;
export const { selectScreenSize, selectBreakpoint } = screen.selectors;
export default screen.reducer;
